import * as React from 'react';
import * as ProgressBarPrimitive from '@radix-ui/react-progress';

import { cn } from './cn';

const TONE_FILL_CLASSNAMES = {
    primary: 'tw-bg-primary',
    secondary: 'tw-bg-secondary'
};

const ProgressBar = React.forwardRef(({
    className: _className,
    style: _style,
    tone = 'primary',
    value,
    ...props
}, ref) => (
    <ProgressBarPrimitive.Root
        ref={ref}
        className="tw-relative tw-h-2 tw-w-full tw-overflow-hidden tw-rounded-full tw-bg-muted"
        {...props}
    >
        <ProgressBarPrimitive.Indicator
            className={cn('tw-h-full tw-w-full tw-flex-1 tw-transition-all', TONE_FILL_CLASSNAMES[tone])}
            style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
        />
    </ProgressBarPrimitive.Root>
));

ProgressBar.displayName = ProgressBarPrimitive.Root.displayName;

export { ProgressBar };
